import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import {
  IonPage,
  IonHeader,
  IonToolbar,
  IonTitle,
  IonContent,
  IonCard,
  IonCardHeader,
  IonCardTitle,
  IonCardContent,
  IonItem,
  IonLabel,
  IonInput,
  IonButton,
  IonIcon,
  IonText
} from '@ionic/react';
import { arrowBackOutline, keyOutline, personOutline } from 'ionicons/icons';
import MedicalNotesParkingLot from './MedicalNotesParkingLot';

const MedicalNotesParkingLotTestHarness = () => {
  const history = useHistory();
  const [authToken, setAuthToken] = useState('');
  const [userId, setUserId] = useState('');
  const [showParkingLot, setShowParkingLot] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (showParkingLot && authToken && userId) {
      localStorage.setItem('auth_token', authToken);
      localStorage.setItem('user_id', userId);
      window.postMessage(
        {
          type: 'AUTH_DATA',
          auth_token: authToken,
          user_id: userId
        },
        window.origin
      );
    }
  }, [showParkingLot, authToken, userId]);

  const handleLaunch = () => {
    if (!authToken.trim() || !userId.trim()) {
      setError('Both auth token and user ID are required.');
      return;
    }
    setError(null);
    setShowParkingLot(true);
  };

  if (showParkingLot) {
    return (
      <IonPage>
        <IonHeader>
          <IonToolbar>
            <IonButton fill="clear" slot="start" onClick={() => history.goBack()}>
              <IonIcon icon={arrowBackOutline} />
            </IonButton>
            <IonTitle>Medical Notes Parking Lot</IonTitle>
          </IonToolbar>
        </IonHeader>
        <IonContent fullscreen>
          <MedicalNotesParkingLot />
        </IonContent>
      </IonPage>
    );
  }

  return (
    <IonPage>
      <IonHeader>
        <IonToolbar>
          <IonButton fill="clear" slot="start" onClick={() => history.goBack()}>
            <IonIcon icon={arrowBackOutline} />
          </IonButton>
          <IonTitle>Medical Notes Parking Lot Test Harness</IonTitle>
        </IonToolbar>
      </IonHeader>
      <IonContent>
        <div style={{ padding: '16px' }}>
          <IonCard>
            <IonCardHeader>
              <IonCardTitle>Authentication</IonCardTitle>
            </IonCardHeader>
            <IonCardContent>
              <IonItem>
                <IonIcon icon={keyOutline} slot="start" />
                <IonLabel position="stacked">Auth Token *</IonLabel>
                <IonInput
                  value={authToken}
                  onIonInput={(e) => setAuthToken(e.detail.value ?? '')}
                  placeholder="Enter an auth token"
                  clearInput
                />
              </IonItem>
              <IonItem>
                <IonIcon icon={personOutline} slot="start" />
                <IonLabel position="stacked">User ID *</IonLabel>
                <IonInput
                  value={userId}
                  onIonInput={(e) => setUserId(e.detail.value ?? '')}
                  placeholder="Enter a user ID"
                  clearInput
                />
              </IonItem>
            </IonCardContent>
          </IonCard>

          {error && (
            <IonCard color="danger">
              <IonCardContent>
                <IonText color="light">{error}</IonText>
              </IonCardContent>
            </IonCard>
          )}

          <div style={{ textAlign: 'center', marginTop: '24px' }}>
            <IonButton expand="block" onClick={handleLaunch}>
              Launch Medical Notes Parking Lot
            </IonButton>
          </div>
        </div>
      </IonContent>
    </IonPage>
  );
};

export default MedicalNotesParkingLotTestHarness;


